module.exports = __webpack_public_path__ + "img/resume_logo.17215ba5.png";